import Alert from "@pathwright/ui/src/components/alert/Alert"
import Card from "@pathwright/ui/src/components/card/Card"
import CardBlock from "@pathwright/ui/src/components/card/CardBlock"
import { Card as CardT } from "@pathwright/ui/src/components/card/types"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import PropTypes from "prop-types"
import {
  ContextualFeaturePermissionQueryVariables,
  useContextualFeaturePermissionQuery
} from "@pathwright/graphql-client/src/generated"
import FeatureBlockItem from "../block/FeatureBlockItem"
import FeaturePermissionsAuthLoginForm from "../form/FeaturePermissionsAuthLoginForm"
import { featurePermissionsQueryPropTypes } from "../propTypes"

const ManageFeaturesAuthLoginFeature = ({
  card,
  ...variables
}: {
  card: CardT
} & ContextualFeaturePermissionQueryVariables) => {
  const cfpQuery = useContextualFeaturePermissionQuery({
    variables
  })

  const feature = cfpQuery.data?.contextualFeaturePermission

  return (
    <Card card={card} emphasis="secondary">
      {cfpQuery.loading ? (
        <LoadingCircle center />
      ) : cfpQuery.error ? (
        <Alert error={cfpQuery.error} />
      ) : feature ? (
        <CardBlock paddingTop={false} paddingBottom={false}>
          <FeatureBlockItem feature={feature} />
          <FeaturePermissionsAuthLoginForm
            featureKey={feature.feature_key}
            context={null}
          />
        </CardBlock>
      ) : null}
    </Card>
  )
}

ManageFeaturesAuthLoginFeature.displayName = "ManageFeaturesAuthLoginFeature"

ManageFeaturesAuthLoginFeature.propTypes = {
  // provided by CardStack > CardStackCard
  card: PropTypes.object.isRequired,
  ...featurePermissionsQueryPropTypes
}

export default ManageFeaturesAuthLoginFeature
